import React, {forwardRef, ReactNode, useEffect, useImperativeHandle, useState} from "react";
import {Button, Checkbox, ConfigProvider, Input, message, Modal, Select, Tabs, Tag} from "antd";
import "./DialogExport.css"
import "@/publish.css"
import Global from '@/global'
import {ipcSend} from "@/common/ipc";
import clipboard from "clipboardy";
import {hasLicense, imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import {deletePublishNote, getPublishNoteById, updatePublishNote} from "@model/publishNote";
import {TPublishNote} from "@/index";
import {DeleteOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {IconClose, IconPageBlack} from "@/Icon";
import type {SelectProps} from "antd";
import {getUserInfo, noteInfoById, noteRemovePublish} from "@/api/Api";

let mszNoteId;//分享的ID
const DialogExport = forwardRef(function (props:{onCloseDialog:any,onExportEvent:any},ref){
    useImperativeHandle(ref,()=>({
        onDialogShow:onDialogShow,
        onShareWebFinished:onShareWebFinished
    }))
    const {t} = useTranslation();
    const tabItems = [
        {
            key:'export',
            label:'Export as',
            children:''
        },
        {
            key:'publish',
            label:'Publish',
            children:''
        }
    ]
    const [tabKey,setTableKey] = useState('export');
    const [hasPublishLic,setHasPublishLic] = useState(false);
    const [shareUrl,setShareUrl] = useState('');
    const [dialogWidth,setDialogWidth] = useState('450px');
    const [isTextHover,setIsTextHover]=useState(false);
    const [arrayPages,setArrayPages]=useState([]);
    const [isExportPng,setIsExportPng] = useState(false);
    const [selectDefaultValues,setSelectDefaultValues] = useState([]);
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [publishDesc,setPublishDesc] = useState(t("Publish"));
    type TagRender = SelectProps['tagRender'];

    useEffect(()=>{
        resetDialog();
    },[])

    const onTabChanged = (activeKey)=>{
        setTableKey(activeKey);
        // if ("export" === activeKey){
        //     setDialogWidth('310px');
        // }else{
        //     setDialogWidth('450px');
        // }
    }

    const onExportClick = (szExportType:string)=>{
        setIsShowDialog(false);
        props.onExportEvent(szExportType);
        props.onCloseDialog();
    }

    /**
     * 重置数据
     */
    const resetDialog = async ()=>{
        setShareUrl('');
        setTableKey('export')
        setPublishDesc(t("Publish"))
        //根据noteid查询是否有过分享url
        if(!isStringNullOrEmpty(mszNoteId)){
            const publishNote = await getPublishNoteById(mszNoteId);
            if(publishNote != null){
                setShareUrl(publishNote.publishUrl);
                setPublishDesc(t("Publish Changes"))
            }
            // noteInfoById(mszNoteId,()=>{}).then(res=>{
            //
            // });
        }

        if(hasLicense()){
            setHasPublishLic(true);
        }

        if (import.meta.env.DEV){
            // setHasPublishLic(true);
        }
    }

    const onDialogShow = (szNoteId:string,arrayMenuDatas:any,arraySelectKeys:string[])=>{
        setIsShowDialog(true);

        mszNoteId = szNoteId;
        //get all page...
        var arrayPages = [];
        let szCurrentKey = '';
        if (arraySelectKeys?.length > 0){
            szCurrentKey = arraySelectKeys[0];
        }
        let arraySelectedValues = [];
        let currentPage:any;
        let arrayNewMenuDatas = [...arrayMenuDatas];

        for (var i=0;i<arrayNewMenuDatas.length;i++){
            var item = arrayNewMenuDatas[i];
            if (item.isFolder){
                for (var j=0;j<item.children.length;j++){
                    var page = item.children[j];
                    if (page.key === szCurrentKey){
                        currentPage = page;
                        page.isChecked = true;
                    }else{
                        page.isChecked = false;
                    }
                    arrayPages.push({
                        ...page,
                        label:page.title,
                        value:page.key
                    });
                }
            }else{
                if (item.key === szCurrentKey){
                    currentPage = item;
                    item.isChecked = true;
                }else{
                    item.isChecked = false;
                }
                arrayPages.push({
                    ...item,
                    label:item.title,
                    value:item.key
                });
            }
        }

        //添加到默认选择.
        arraySelectedValues.push(currentPage?.key);

        //first.
        arrayPages.splice(0,0,{
            title:t("All pages")+"(1-"+arrayPages.length+")",
            key:'all'
        },{
            ...currentPage,
            title:t("Current page")+"("+currentPage?.title+")",
            key:currentPage?.key+1,
            extra:true,
            isChecked:true
        })
        setArrayPages(arrayPages);
        setIsExportPng(false);

        setSelectDefaultValues(arraySelectedValues);

        resetDialog();
        //刷新登录...
        getUserInfo({},()=>{}).then((res)=>{
            Global.g_userInfo = res;
            setHasPublishLic(hasLicense);
        })
    }
    /**
     * web分享结果
     */
    const onShareWebFinished = (szWebUrl:string,noteId:string)=>{
        if (isStringNullOrEmpty(shareUrl)){
            //first
            setPublishDesc(t("View site"))
        }else{
            setPublishDesc("Publish Changes")
        }
        setShareUrl(szWebUrl);
        //保存到本地
        var pNote:TPublishNote ={
            id: mszNoteId, noteId: mszNoteId, publishUrl: szWebUrl,type:'project'
        }
        updatePublishNote(pNote);
    }

    /**
     * 复制地址
     */
    const onCopyUrl = ()=>{
        clipboard.write(shareUrl);
        message.info(t("Share addr has copyed"))
    }

    /**
     * 移除链接
     */
    const onRemoveLink = ()=>{
        Modal.confirm({
            content:t("Confirm remove share url"),
            centered:true,
            onOk(){
                deletePublishNote(mszNoteId);
                setShareUrl('');
                noteRemovePublish({id:mszNoteId},()=>{

                }).then(res=>{
                    console.log("remove publish"+res);
                })
            },
        })
    }

    /*下拉更改*/
    const onSelectPageItemClicked = (e)=>{
        const szKey = e.currentTarget.dataset.key;
        var arrayNewPages = [...arrayPages];

        let isChecked = false;

        let arraySelectKeys = [];
        for (let i=0;i<arrayNewPages.length;i++){
            var item = arrayNewPages[i];

            if (item.key.startsWith(szKey) || szKey.startsWith(item.key)){
                item.isChecked = !item.isChecked;
                isChecked = item.isChecked;
            }

            if (szKey === 'all'){
                //all
                item.isChecked = isChecked;
            }

            if (item.isChecked && !item.extra && item.key !== 'all'){
                arraySelectKeys.push(item.key);
            }
        }

        setArrayPages(arrayNewPages);
        setSelectDefaultValues(arraySelectKeys);
    }

    const onPageChanged = (e)=>{

    }

    /**
     * 当前选中的条目
     */
    const getSelectedPages = ()=>{
        let arraySelectPages = [];
        //前2个不算....
        for (let i=2;i<arrayPages.length;i++) {
            var item = arrayPages[i];
            if (item.isChecked && item.key !== 'all'){
                arraySelectPages.push(item);
            }
        }
        return arraySelectPages;
    }

    const reanderTag:TagRender = (props)=>{
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
        };
        return (
            <Tag
                onMouseDown={onPreventMouseDown}
                closable={false}
                onClose={onClose}
                style={{ marginRight: 3 }}
            >
                {label}
            </Tag>
        );
    }

    function renderTabContent(){
        if ('export' === tabKey){
            return(
                <>
                    <ul className='ul-export' style={{marginBottom:'-16px',display:isExportPng?'none':'inherit'}}>
                        <li onClick={()=>onExportClick('exportCanvas')}>
                            <img className='img-mini-small' src={imgPathPerfix()+"export_pcanvas.png"}/>
                            <span>{t("Output pcanvas")}</span>
                        </li>
                        <li onClick={()=>onExportClick('exportCanvasx')}>
                            <img className='img-mini-small' src={imgPathPerfix()+"export_pcanvasx.png"}/>
                            <span>{t("Output pcanvasx")}</span>
                        </li>
                        <li onClick={()=>
                            // onExportClick('exportPng')
                            setIsExportPng(true)
                        }>
                            <img className='img-mini-small' src={imgPathPerfix()+"export_image.png"}/>
                            <span>{t("Output png")}</span>
                        </li>
                    </ul>

                    <div style={{display:isExportPng?'flex':'none',flexDirection:'column',marginTop:'0px'}}>
                        <p className='flex-row-vertical-center mb-6'>
                            <img className='img-mini-small mr-8' src={imgPathPerfix()+"export_image.png"}/>
                            <span>{t("Output png")}</span>
                        </p>
                        <Select
                            tagRender={reanderTag}
                            showSearch={false}
                            mode="multiple"
                            size={'middle'}
                            placeholder="Please select"
                            defaultValue={selectDefaultValues}
                            value={selectDefaultValues}
                            onChange={onPageChanged}
                            maxTagCount={4}
                            style={{ width: '100%' }}
                            options={arrayPages}
                            dropdownRender={(menu => {
                                return(
                                    <div style={{display:'flex',flexDirection:'column',maxHeight:'300px',overflowX:'hidden',overflowY:'auto'}}>{
                                        arrayPages.map((item)=>(
                                            <div key={item.key} className='flex-row-vertical-center hovered'
                                                 data-key={item.key}
                                                 onClick={onSelectPageItemClicked}
                                                 style={{height:'34px',lineHeight:'34px',padding:'0 8px'}}>
                                                <img className='img-mini-small mr-8' style={{display:(item.key=="all" || item.extra)?"none":'inherit'}} src={imgPathPerfix()+"page_black.png"}/>
                                                <span style={{flexGrow:'1'}}>{item.title}</span>
                                                <Checkbox checked={item.isChecked}/>
                                            </div>
                                        ))
                                    }
                                    </div>
                                )
                            })}
                        />

                        <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'16px',marginBottom:'-6px'}}>
                            <Button className='large-w-button' onClick={()=>setIsShowDialog(false)}>{t("Cancel")}</Button>
                            <Button disabled={selectDefaultValues.length == 0} className='large-w-button button-solid-style'
                                    type="primary"
                                    onClick={()=>{
                                        setIsShowDialog(false)
                                        props.onExportEvent("exportPng",getSelectedPages());
                                    }}
                                    style={{marginLeft:'26px'}}
                                    htmlType={"submit"}>{t("Export")}</Button>
                        </div>
                    </div>

                </>
            )
        }else if('publish' == tabKey){
            return(
                <div style={{position:'relative',marginTop:'-6px',marginBottom:'-16px'}}>
                    <h4>{t("Share to web")}</h4>
                    <span style={{color:'var(--text-color-7)'}}>{t("Create a link")}</span>
                    <div className='flex mt-6'>
                        <Input placeholder='http://app.noteey.com/..' readOnly={true} value={shareUrl}/>
                        <Button style={{display:isStringNullOrEmpty(shareUrl)?'none':'inline'}} className='ml-6 button-solid-style' type={"primary"} onClick={onCopyUrl}>{t("Copy")}</Button>
                    </div>
                    <div onClick={()=>{
                        if (publishDesc === t("View site")){
                            ipcSend("open-url",shareUrl);
                        }else{
                            props.onExportEvent('exportWeb')
                        }
                    }} className='flex-center' style={{width:'100%'}}>
                        <Button className='mt-16 button-solid-style' style={{width:'100%'}} type={"primary"}>{publishDesc}</Button>
                    </div>

                    <div className='flex-center' style={{visibility:hasPublishLic?'hidden':'visible',
                        backgroundColor:'#00000088',
                        borderRadius:'6px',
                        backdropFilter:'blur(2px)',
                        width:'calc(100% + 24px)',
                        height:'calc(100% + 16px)',
                        position:'absolute',left:'0',top:'0',
                        zIndex:'99',margin:'-10px -12px 32px -12px'
                    }}>
                        <span onMouseEnter={()=>setIsTextHover(true)} onMouseLeave={()=>setIsTextHover(false)}
                              style={{color:isTextHover?'#eeeeee':'white',textDecoration:'underline',cursor:isTextHover?'pointer':'default'}}
                              onClick={()=>{
                                  setIsShowDialog(false)
                                  ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_VIP);
                              }}>{t("Use publish must purchase")}</span>
                    </div>

                    <div style={{display:isStringNullOrEmpty(shareUrl)?'none':'flex',alignItems:'center'}} className='mt-16' >
                        <div className='hovered flex-center' onClick={()=>onRemoveLink()}>
                            <img className='img-mini-small' src={imgPathPerfix()+"remove.png"}/>
                            <span className='ml-6 mt-2'>{t("Remove Link")}</span>
                        </div>

                    </div>
                </div>
            )
        }
    }

    return(
        <Modal open={isShowDialog} closeIcon={<IconClose/>}
               centered={true} width={dialogWidth}
               onCancel={()=>setIsShowDialog(false)} closable={false} footer={''} destroyOnClose={true}>
            <ConfigProvider
                theme={{
                components: {
                    Tabs: {
                        /* 这里是你的组件 token */
                        itemColor:'var(--tab-text-color)',
                        itemActiveColor:'var(--text-color)',
                        itemHoverColor:'var(--text-color)',
                        itemSelectedColor:'var(--text-color)',
                        inkBarColor:'var(--text-color)'
                    },
                },
            }}>
                <Tabs items={tabItems} onChange={onTabChanged} style={{marginTop:'-12px'}}>

                </Tabs>
            </ConfigProvider>

            {renderTabContent()}
        </Modal>
    )
})
export default React.memo(DialogExport);
























